import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    name: "notificationStockage",
})

export default class NotificationStockage extends Vue {
    private showButtons: boolean;

    constructor() {
        super();

        this.showButtons = false;
    }

    public toggleButtons(): void {
        this.showButtons = this.showButtons ? false : true;
    }
}
